import React from 'react';
import {Box} from "@mui/material";
import ContentTitles from "@/ui/content-titles/content-titles";
import ContactForm from "@/ui/contact-form/contact-form";
import ContactUsTiles from "@/ui/contact-us-tiles/contact-us-tiles";

type ContactSnippetProps = {
    title: string;
    description?: string;
    showContactButton?: boolean;
    showContactInformation?: boolean;
    scrambleTitle?: boolean;
    contactButtonText?: string;
};

const ContactSnippet: React.FC<ContactSnippetProps> = ({
                                                           title,
                                                           description,
                                                           showContactButton = true,
                                                           showContactInformation = true,
                                                           contactButtonText = 'Contact Us',
                                                           scrambleTitle = true,
                                                       }) => {


    return (
        <Box p={5}
             sx={(theme) => (
                 {
                     justifyItems: 'center',
                     borderTop: `1px solid ${theme.palette.primary.main}`,
                     borderBottom: `1px solid ${theme.palette.primary.main}`,
                     backgroundColor: theme.palette.background.paper,
                 }
             )}
        >
            <ContentTitles title={title} scrambleTitle={scrambleTitle} titleVariant='h4' subTitle={description || ''}/>
            {showContactButton && (
                <Box sx={{width: '100%', textAlign: 'center'}}>
                    <ContactForm buttonMessage={contactButtonText}/>
                </Box>
            )}
            {showContactInformation && (
                <ContactUsTiles hidePhone={false} />
            )}
        </Box>
    );
};

export default ContactSnippet;
